const notifChannel = new BroadcastChannel('websms_notification_channel')
export default notifChannel
